import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../lib/api-client';

export const programKeys = {
  all: ['programs'] as const,
  lists: () => [...programKeys.all, 'list'] as const,
  list: (params: Record<string, unknown>) => [...programKeys.all, 'list', params] as const,
  details: () => [...programKeys.all, 'detail'] as const,
  detail: (id: string) => [...programKeys.details(), id] as const,
};

export function usePrograms(params?: { page?: number; limit?: number; status?: string }) {
  return useQuery({
    queryKey: programKeys.list(params || {}),
    queryFn: () => apiClient.programs.list(params),
  });
}

export function useProgram(id: string) {
  return useQuery({
    queryKey: programKeys.detail(id),
    queryFn: () => apiClient.programs.get(id),
    enabled: !!id,
  });
}

/** Lightweight program lookup for shareable registration links. */
export function useRegistrationProgram(reference: string) {
  return useQuery({
    queryKey: [...programKeys.details(), 'registration-link', reference],
    queryFn: () => apiClient.programs.getRegistrationLink(reference),
    enabled: !!reference,
  });
}
